import { createContext } from 'react';

import { useGuardedContext } from '@/hooks/useGuardedContext';

import { ChatSideContent } from '../chatSideContent.types';

export interface ChatSideContentContextValue {
  /** The content currently shown in the side pane; null when the pane is closed. */
  sideContent: ChatSideContent | null;
  /**
   * Increments on every openSideContent call. The pane keys its body on this,
   * so replacing the content (e.g. clicking another citation while one is
   * open) remounts the body with fresh state — the same reset the citation
   * modal used to get from unmounting between opens.
   */
  sideContentKey: number;
  /** Shows content in the side pane, replacing whatever is currently open. */
  openSideContent: (content: ChatSideContent) => void;
  closeSideContent: () => void;
}

export const ChatSideContentContext = createContext<
  ChatSideContentContextValue | undefined
>(undefined);

export function useChatSideContentContext() {
  return useGuardedContext(ChatSideContentContext, 'ChatSideContentProvider');
}
